export default __webpack_public_path__ + "static/media/default-project-image.2b81f86b.jpg";